import { createUseStyles } from 'react-jss';
import colors from "../../../utils/colors";

var styles = {
  checkbox: {
    marginBottom: '1rem',
    '& svg': {
      fill: colors.blue[600]
    },
    '& label': {
      cursor: 'pointer'
    }
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map